import { render, staticRenderFns } from "./RandomColorWidget.vue?vue&type=template&id=08807786&scoped=true&"
import script from "./RandomColorWidget.vue?vue&type=script&lang=ts&"
export * from "./RandomColorWidget.vue?vue&type=script&lang=ts&"
import style0 from "./RandomColorWidget.vue?vue&type=style&index=0&id=08807786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08807786",
  null
  
)

export default component.exports